export const comment = `コメントテキストコメントテキストコメントテキストコメントテキストコメントテキストコメントテキストコメントテキストコメントテキストコメントテキストコメントテキストコメントテキストコメントテキストコメントテキストコメントテキストコメントテキストコメントテキスト。`;

export const sugisaki_hana_comment = `この物語は、ひとりの人物の失敗から始まります。
私はその出来事に温もりの眼差しを向けることはできないけれど、失敗に向き合い、責任を取ろうとする姿を見捨ててはいけないと思いました。“再生を見守る”という世の中のあるべき姿のひとつとして、この映画に関わる価値を感じ、緊張を抱きながら演じました。
いつの日か失敗してしまったことのある誰かにも、他者の失敗を許してあげられない誰かにも、この映画が届いてほしいです。`;

export const sugisaki_hana_profile = `プロフィール：
1997年10月2日生まれ。
映画「湯を沸かすほどの熱い愛」で第４０回日本アカデミー賞最優秀助演女優賞・新人俳優賞はじめ、多くの映画賞を受賞。
主な出演作に、ドラマ「花のち晴れ～花男Next Season～」（TBS/ 18）、NHK連続テレビ小説「おちょやん」（20～21）、「杉咲花の撮休」（WOWOW/ 23）、映画「トイレのピエタ」（15）、「十二人の死にたい子どもたち」（19）、「青くて痛くて脆い」（20）、「99.9―刑事専門弁護士―」（21）、「大名倒産」（23）、「法廷遊戯」（23）、「市子」（23）などがある。「５２ヘルツのクジラたち」（23年3月1日公開）、「片思い世界」（25年公開予定）など話題作の公開が控える。`;

export const hagiwara_riku_comment = `磯川俊一役を演じました萩原利久です。
今回作品を通じて、モノや景色、起こる１つ１つの出来事に対して、当事者なのか部外者なのか、はたまた環境なのか立場なのか、主観客観、人間社会において様々な視点を感じました。自分自身も演じた当時と今とでは全く異なる見え方に変化していることもあるかもしれません。でも、自分なりに向き合った現場で演者として身体で感じた緊張や刺激は鮮明に残っています。素晴らしい経験をさせてもらい今もいき続けています。
1人でも多くの方に観ていただけたら嬉しいです。`;

export const hagiwara_riku_profile = `プロフィール：
1999年2月28日生まれ。埼玉県出身。
主な出演作にドラマ「美しい彼」(MBS)、「月読くんの禁断お夜食」(テレビ朝日)、「真夏のシンデレラ」(フジテレビ)、「たとえあなたを忘れても」(ABC)、映画『劇場版 美しい彼〜eternal〜』（23）、『おとななじみ』（23）、『キングダム運命の炎』（23）、『ミステリと言う勿れ』（23）など。`;

export const hara_hiroto_comment = `撮影したのは去年の春に差し掛かる頃でした。
タイトルにある通り「サクラ」がキーワードになってきます。
「正義」とは一体何か？
それぞれの「正義」が交錯する時に、サクラを魅せることで物語の骨格を表現したい。
スタッフ・キャストと共に考え、アイディアを出し合い、全力で撮影していきました。
森口泉を演じる杉咲花さんの真っ直ぐ真相を見つめる眼は、僕自身何度も鳥肌が止まりませんでした。`;

export const hara_hiroto_profile = `プロフィール：
2011年BABEL LABEL加入。
ドラマ『日本ボロ宿紀行』(19／TX)では監督に加え撮影監督を務める。以降、『八月は夜のバッティングセンターで。』（21／TX）、『真夜中にハロー！』（22／TX）『ウツボラ』(23／WOWOW)などを演出。『帰ってきた あぶない刑事』（2024年5月24日）の公開も控える。`;

export const yuzuki_yuko_comment = `この作品は、世の中の理不尽や不条理なことに、懸命に立ち向かっていく人間を書きたくて出来上がったものです。
主人公の森口泉は、親友の死をきっかけに事件の真相と社会の闇に迫っていきます。泉は、迷いながら、悩みながら、ときに諦めそうになりながらも、必死に前に進んでいきます。がんばる泉を、杉咲花さんがどのように演じてくださるのか、とても楽しみです。泉を、そして作品に登場する人々を応援しています。`;

export const yuzuki_yuko_profile = `プロフィール：
1968年岩手県出身。2008年『臨床真理』で第7回「このミステリーがすごい！」大賞を受賞しデビュー。13年『検事の本懐』で第15回大藪春彦賞、16年『孤狼の血』で第69回日本推理作家協会賞（長編及び連作短編集部門）を受賞。18年『盤上の向日葵』で「2018年本屋大賞」2位。その他の著書に『慈雨』『合理的にあり得ない』『暴虎の牙』『月下のサクラ』『ミカエルの鼓動』『教誨』『風に立つ』など。`;

export const toyohara_kousuke_comment = `個々において大切にする思いと組織の論理。誰もが一個人であるはずが一体どこから権力と同化し真実を濁らせてしまうのか。人間の営みと社会の構造、つねに私の心にも横たわる深い問いがこの物語に描かれています。
私が演じた梶山という男もまた警察という大きな組織の一員でありますが、このひとりの人間が生きる矜持と生きる問いを共に感じ、胸に携えて撮影に臨んだつもりです。
本当のことはいつも見えづらくて、本当の言葉はいつも喉に詰まってしまいそうになるけれど、それでもしっかりとまっすぐな瞳でいることの強さを心に残してもらえたらと願っています。`;

export const toyohara_kousuke_profile = `プロフィール：
1965年9月25日生まれ。東京都出身。
主な出演作に映画『ヤクザと家族 The Family』(21)、『さかなのこ』(22)、『キリエのうた』（23）、『福田村事件』（23）、WOWOWオリジナルドラマ「TOKYO VICE」(22)など。シンセカイ合同会社を2018年に設立。第1回プロデュース作品に『ソワレ』（20）がある。`;

export const yasuda_ken_comment = `試写でこの映画を拝見したとき、その面白さに唸りました。
登場人物の入り乱れる感情、秘める思惑、そして抱く決意。
様々な表情が垣間見える作品です。
これらの点が線となったとき、皆様の目に見えるもの・胸に届くものは異なるかと思います。その一方で、どのように届くのかが興味深いほど、この作品の受け取り方には数えきれない色があると感じています。
原作・脚本・演出・出演者の皆様、何拍子も揃った臨場感を十分に味わえる仕上がり。
原監督の手腕に脱帽です。
是非、劇場でご覧ください。`;

export const yasuda_ken_profile = `プロフィール：
1973年12月8日生まれ。北海道出身。
主な出演作にドラマ「下町ロケット」シリーズ（TBS）、「PICU 小児集中治療室」（フジテレビ）、映画『家に帰ると妻が必ず死んだふりをしています。』（18）、『愛しのアイリーン』（18）、『私はいったい、何と闘っているのか』（21）、『とんび』（22）、『ラーゲリより愛を込めて』（22）、『アントニオ猪木をさがして』（23）など。`;
